module.exports = __webpack_public_path__ + "img/google-slides-3.1d95eb2d.webp";